module.exports = __webpack_public_path__ + "static/media/copyForward.04ba19ef.svg";